import { render } from "./GrantComponent.vue?vue&type=template&id=7547fbcf"
import script from "./GrantComponent.vue?vue&type=script&lang=js"
export * from "./GrantComponent.vue?vue&type=script&lang=js"

import "./GrantComponent.vue?vue&type=style&index=0&id=7547fbcf&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__